var _path, _path2, _path3, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStartsWith(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.793 11h-1.02L7.27 9.574H5.066L4.582 11H3.566l2.098-5.602h1.047L8.793 11zm-1.77-2.184l-.777-2.234a2.648 2.648 0 01-.074-.352h-.016c-.023.149-.05.266-.078.352l-.77 2.234h1.715zm2.817 2.27a.564.564 0 01-.399-.152.495.495 0 01-.164-.371.5.5 0 01.164-.376.556.556 0 01.399-.156c.159 0 .293.052.402.156.112.105.168.23.168.376a.49.49 0 01-.168.37.57.57 0 01-.402.153zm1.93 0a.564.564 0 01-.399-.152.495.495 0 01-.164-.371.5.5 0 01.164-.376.556.556 0 01.399-.156c.158 0 .293.052.402.156.112.105.168.23.168.376a.49.49 0 01-.168.37.57.57 0 01-.402.153z",
    fill: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "StartsWith_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 13,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M1 3h13v10H1z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#StartsWith_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 3.5,
    width: 14,
    height: 9,
    rx: 1.5,
    stroke: "#C6C6C6"
  }))));
}

export default SvgStartsWith;